import { getSrcs } from '@helpers/image';
import * as React from 'react';
import S from './InnerPageHero.styles';
import { formatDate, formatDateISO } from '@helpers/date';
import LinkButton from '@stories/Components/Global/Buttons/LinkButton/LinkButton';
import FormModal from '../FormModal/FormModal';
const InnerPageHero = (props) => {
    if (!props.title) {
        return null;
    }
    const cssVars = {
        '--blur': props.imageBlur ? `${props.imageBlur}px` : undefined,
        '--tint': props.imageTint ? props.imageTint : undefined,
    };
    const srcs = props.image ? getSrcs(props.image, 2568, 375, 8) : [];
    return (React.createElement(S.Container, { "data-contains-image": !!props.image, style: cssVars },
        React.createElement(S.ContentWrapper, null,
            props.image && (React.createElement(S.ImageWrapper, null,
                React.createElement(S.Image, { alt: props.image.altText ?? '', loading: "eager", role: props.image.altText ? undefined : 'presentation', src: srcs[0].split(' ')[0], srcSet: srcs.join(',') }),
                props.showOverlay && React.createElement(S.Overlay, null))),
            React.createElement(S.Inner, null,
                props.tagline && React.createElement(S.Tagline, null, props.tagline),
                React.createElement(S.Title, null, props.title),
                props.date && (React.createElement(S.Date, { dateTime: formatDateISO(props.date) }, formatDate(props.date))),
                React.createElement(S.TypeList, null,
                    props.resourceType && props.resourceType.length > 0 && (React.createElement(React.Fragment, null, props.resourceType?.map((type) => (React.createElement(S.TypeItem, { key: type }, type))))),
                    props.sector && props.sector.length > 0 && (React.createElement(React.Fragment, null, props.sector?.map((type) => (React.createElement(S.TypeItem, { key: type }, type))))),
                    props.serviceCategory && props.serviceCategory.length > 0 && (React.createElement(React.Fragment, null, props.serviceCategory?.map((type) => (React.createElement(S.TypeItem, { key: type }, type)))))),
                props.content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } }),
                props.cta && (React.createElement(S.CtaWrapper, null,
                    React.createElement(LinkButton, { buttonType: "inverted", href: props.cta.url, target: props.cta.target ?? '_self' }, props.cta.text))),
                props.formModal && (React.createElement(S.CtaWrapper, null,
                    React.createElement(FormModal, { ...props.formModal })))))));
};
export default InnerPageHero;
